function logger(service) {
  return function (label, details) {
    try {
      service(label, details);
    } catch (error) {
      console.warn('Could not find external service to log to', {
        label: label,
        details: details
      });
    }
  };
}

// @ts-ignore
export default logger(window.newrelic && window.newrelic.addPageAction);

// example of future service we want to use, that doesn't use labels
// export default logger((label, details) => newservice(details));